import { Modal, Table, Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

export function ModalWithRefuse(props) {
    
  const {show, setShow, words} = props;  //useState(false);

  return (
    <>      
      <Modal show={show} onHide={() => setShow(false)} className='dark-modal' >
        <Modal.Header closeButton>
          <Modal.Title>Слова игнор списка</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Название</th>
              </tr>
            </thead>
            <tbody>
              {words.map((item) => (
                <tr>
                  <td>{item}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Закрыть
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}